import React from 'react';
import _ from 'lodash';

class SaleCallTableWidget extends React.Component {

    static isInt(value) {
        return !isNaN(value) && (x => (x || 0) === x)(parseFloat(value));
    }

    static getThirdColumn(type) {
        if (_.includes(['bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings'], type)) return 'Möten';
        if (_.includes(['createdActivities', 'activities', 'completedActivities', 'planedActivities'], type)) return 'Aktiviteter';
        if (_.includes(['opportunities', 'createdOpportunities'], type)) return 'Affärsmöjlighet';

        return 'Försäljning';
    }

    static shouldHaveFourthColumn(type) {
        if (_.includes(['activities', 'createdActivities', 'completedActivities', 'planedActivities',
                        'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings'], type)) return false;
        return true;
    }

    static getBestOfList(rows, entity) {              
        const max = _.maxBy(rows, entity);
        const bestOfList = _.filter(rows, row => row[entity] === max[entity]);
    
        let list = bestOfList.map(best => best[entity]);
        return list;
    }

    newRender() {
        const { widget, widgetData } = this.props;
        
        //set entity as which columns the user wants to see
        let entity;
        const columns = ['#', 'name'];
        if (widget.displayConfig && widget.displayConfig.labelType === 'onlyCalls') {
            entity = 'numberOfCalls';
            columns.push('numberOfCalls');
        } else if (widget.displayConfig && widget.displayConfig.labelType === 'onlyDuration') {
            entity = 'durationInMins';
            columns.push('durationInMins');
        } else {
            entity = 'numberOfCalls'; //if none selected than sort by calls by default
            columns.push('durationInMins','numberOfCalls');
        }
        
        // Always fill the table with at least one row to get the header to not be in the middle.
        const defaultWidgetData = widgetData.length ? widgetData : [];

        //display a loading sign if widgetData is empty or if the entity selected by user to display has no value yet        
        if (!defaultWidgetData.length || 
            (widget.displayConfig && widget.displayConfig.labelType && defaultWidgetData[0][entity] === undefined )) {
            return (
                <div className="loading">
                    Loading
                    <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
                </div>
            );
        }

        let shortenedWidgetData;
        if (widget.height < 11) {
            shortenedWidgetData = _.take(defaultWidgetData, 5);
        } else if (widget.height < 16) {
            shortenedWidgetData = _.take(defaultWidgetData, 10);
        } else {
            shortenedWidgetData = defaultWidgetData;
        }

        //sort by entity and add serial number
        shortenedWidgetData = _.orderBy(shortenedWidgetData, [entity], ['desc']);
        shortenedWidgetData.forEach((row, i) => row['#'] = ++i);

        const starStyle = {
            star: {
                color: '#FFD700',
            },
        };

        const rows = shortenedWidgetData.map(row =>
            columns.reduce((result, column) =>
                Object.assign({}, result, { [column]: _.get(row, column) }), {}));

        //get the max value for the entity so we can highlight that row
        const best = SaleCallTableWidget.getBestOfList(rows, entity);

        const table = rows.map((row, i) => {
            const columns = _.map(row, (property, index) => {
                if (SaleCallTableWidget.isInt(property)) {
                    if (index === '#' && row[entity] >= best[0]) {
                        return <span className="fa fa-star" style={starStyle.star} key={index}></span>;
                    }

                    return (
                        <span style={{textAlign:'center'}} key={index}>
                            {property}
                        </span>
                    );
                }

                return <span key={index}>{property}</span>;
            });

            return (
                <li className={row[entity] >= best[0] ? 'budget_achieved_table' : ''} key={i}>
                    {columns}
                </li>
            );
        });

        const headers = columns.map(column =>{
            if(column === 'durationInMins') {
                return <span style={{textAlign:'center'}} key={column}>{'Duration in Mins'}</span>;
            } else if(column === 'numberOfCalls') {
                return <span style={{textAlign:'center'}} key={column}>{'Number of Calls'}</span>;
            } else {
                return <span key={column}>{column}</span>;    
            }
        });

        return (
            <div className="table">
                <ul className="table-row">
                    <li className="table-head">
                        {headers}
                    </li>
                    {table}
                </ul>
            </div>
        );
    }

    render() {
        if (this.props.isThumbnail) {
            return (<div className="table" />);
        } else if (_.has(this.props.widget, 'displayConfig.columns')) {
            return this.newRender();
        } 

        return this.newRender();
    }
}

SaleCallTableWidget.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
    companyProfile: React.PropTypes.object,
    currency: React.PropTypes.string,
};

export default SaleCallTableWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/SaleCallTableWidget.jsx
 **/